import { Link } from "react-router-dom";

export const Logo = ({ className = "", showText = true }) => {
  return (
    <Link
      to="/"
      data-testid="header-brand-logo"
      className={`flex items-center gap-3 group ${className}`}
    >
      <svg
        viewBox="0 0 64 64"
        className="h-9 w-9 shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]"
        aria-hidden="true"
      >
        <g
          fill="none"
          stroke="var(--gold)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M32 10 C 26 20, 26 26, 32 32 C 38 26, 38 20, 32 10 Z" />
          <path d="M32 32 C 24 28, 18 28, 14 34 C 20 40, 27 38, 32 32 Z" />
          <path d="M32 32 C 40 28, 46 28, 50 34 C 44 40, 37 38, 32 32 Z" />
          <path d="M18 44 C 24 40, 40 40, 46 44" />
          <path d="M22 50 L 42 50" />
        </g>
        <circle cx="32" cy="30" r="2.6" fill="var(--gold)" />
      </svg>
      {showText && (
        <span className="flex flex-col leading-none">
          <span className="font-serif text-xl font-semibold tracking-tight text-[var(--text)]">
            Devata <span className="text-[var(--gold)]">&amp;</span> DatAsia
          </span>
          <span className="font-mono text-[9px] uppercase tracking-[0.3em] text-[var(--text-2)] mt-1">
            Sacred Khmer Archive
          </span>
        </span>
      )}
    </Link>
  );
};
